import React, {Component} from 'react';
import Header from "./Header";
import ScoreBreakdown from "./ScoreBreakdown";
import './index.scss'

const pages = {
    Overview: 'Overview',
    About: 'About',
    Resources: 'Resources'
};

class Overview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: pages.Overview
        }
    }

    componentDidMount() {
        this.props.getDiversityvcBenchmark();
        this.props.getDiversityvcScore();
        this.props.getDiversityvcCompanyPolicy();
        this.props.getDiversityvcPolicy();
        this.props.getDiversityvcResource();
        this.props.getCompanyFilters();
        this.props.getFilterMap();
        this.props.getAllSolutions();
        this.props.getCompanyInformation();
    }


    _deleteSolution(data) {
        this.props.doDeleteSolution(data);
    }

    _createNewSolution(data) {
        this.props.doCreateNewSolution(data);
    }

    _createNewCompanySolution(data) {
        this.props.doCreateNewCompanySolution(data);
    }

    render() {
        const hasLoaded = this.props.analyze !== undefined;
        if (!hasLoaded) {
            return null;
        }

        const mySolutions = this.props.improve.solutions.allSolutions.filter(x => x.is_my_solution);
        const { diversityvc: { score, benchmark } = {} } = this.props;

        return (
            <div id={'overview'}>
                <Header 
                    score={score}
                    benchmark={benchmark}
                    companyName={this.props.home.companyInformation.name}
                />
                <ScoreBreakdown diversityvc={this.props.diversityvc}/>
            </div>
        );
    }
}

export default Overview;
